import { useState, useEffect, useCallback } from "react";
import { getCurrentUser } from "../api";
import { useNavigate } from "react-router-dom";

export function useAuth() {
  const [currentUser, setCurrentUser] = useState(null);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const navigate = useNavigate();

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      if (window.location.pathname !== "/login") {
        navigate("/login");
      }
      setIsCheckingAuth(false);
      return;
    }

    try {
      const res = await getCurrentUser(token);
      setCurrentUser(res.data);
    } catch (err) {
      console.error("Token invalid:", err);
      // Let existing axios interceptor handle redirect if 401, but we clean up here too
      localStorage.removeItem("token");
      if (window.location.pathname !== "/login") {
        navigate("/login");
      }
    } finally {
      setIsCheckingAuth(false);
    }
  }, [navigate]);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return { currentUser, isCheckingAuth, checkAuth };
}
